import ReactMarkdown, { defaultUrlTransform } from "react-markdown";
import rehypeRaw from "rehype-raw";
import { promoteIntroHeading } from "lib/intro-heading";
import { externalDocumentationUrl } from "lib/external-docs";

interface MarkdownProp {
  content: any;
  primaryIntroHeading?: boolean;
}

const Markdown: React.FC<MarkdownProp> = ({ content, primaryIntroHeading = false }) => (
  <ReactMarkdown
    rehypePlugins={primaryIntroHeading ? [rehypeRaw, promoteIntroHeading] : [rehypeRaw]}
    urlTransform={(uri, key) => {
      const safeUri = defaultUrlTransform(uri);
      if (safeUri && key === "href") return externalDocumentationUrl(safeUri) || safeUri;
      if (!safeUri || key !== "src" || /^https?:\/\//.test(safeUri)) return safeUri;
      return `${process.env.NEXT_PUBLIC_STRAPI_API_URL}${safeUri}`;
    }}
  >
    {content}
  </ReactMarkdown>
);

export default Markdown;
